module.exports = __webpack_public_path__ + "fonts/time.svg?v=2cbef8f5e9c66e29da9d85760b0f47f3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/time.svg
// module id = 699
// module chunks = 0